
String.prototype.english = function(forcePeriod=false) {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return this.replace(new RegExp(`[${persianDigits}]`, 'g'), digit => persianDigits.indexOf(digit)).
        replace('٫', forcePeriod ? '.' : '٫');
};

String.prototype.persian = function(forcePeriod=false) {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return this.replace(/[0-9]/g, index => persianDigits[index]).replace('.', forcePeriod ? '٫' : '.');
};

Number.prototype.persian = function() {
    return this.toString().persian(true);
};

String.prototype.toPercent = function() {
    Number.parseFloat(this).toPercent();
};

Number.prototype.toPercent = function() {
    if (this >= 0)
        return '٪' + (this * 100).toFixed(2);
    else
        return '-٪' + (-this * 100).toFixed(2);
};

Number.prototype.toText = function() {
    if (this < 0)
        return 'منفی ' + (-this).toText();
    if (this < 20)
        return {
            0: 'صفر',
            1: 'یک',
            2: 'دو',
            3: 'سه',
            4: 'چهار',
            5: 'پنج',
            6: 'شش',
            7: 'هفت',
            8: 'هشت',
            9: 'نه',
            10: 'ده',
            11: 'یازده',
            12: 'دوازده',
            13: 'سیزده',
            14: 'چهارده',
            15: 'پانزده',
            16: 'شانزده',
            17: 'هفده',
            18: 'هجده',
            19: 'نوزده',
        }[this];
    if (this < 100) {
        let result = {
            2: 'بیست',
            3: 'سی',
            4: 'چهل',
            5: 'پنجها',
            6: 'شصت',
            7: 'هفتاد',
            8: 'هشتاد',
            9: 'نود',
        }[Math.floor(this / 10)];
        if (this % 10)
            return result + ' و ' + (this % 10).toText();
        else
            return result;
    }
    if (this < 1000) {
        let result = {
            1: 'صد',
            2: 'دویست',
            3: 'سیصد',
            4: 'چهارصد',
            5: 'پانصد',
            6: 'ششصد',
            7: 'هفتصد',
            8: 'هشتصد',
            9: 'نه',
        }[Math.floor(this / 100)];
        if (this % 100)
            return result + ' و ' + (this % 100).toText();
        else
            return result;
    }
    if (this < 1000000) {
        let result = Math.floor(this / 1000).toText() + ' هزار';
        if (this % 1000)
            return result + ' و ' + (this % 1000).toText();
        else
            return result;
    }
    if (this < 1000000000) {
        let result = Math.floor(this / 1000000).toText() + ' میلیون';
        if (this % 1000000)
            return result + ' و ' + (this % 1000000).toText();
        else
            return result;
    }
    if (this < 1000000000000) {
        let result = Math.floor(this / 1000000000).toText() + ' میلیارد';
        if (this % 1000000000)
            return result + ' و ' + (this % 1000000000).toText();
        else
            return result;
    }
    if (this < 1000000000000000) {
        let result = Math.floor(this / 1000000000000).toText() + ' ترلیون';
        if (this % 1000000000000)
            return result + ' و ' + (this % 1000000000000).toText();
        else
            return result;
    }
    return 'خیلی';
};

Number.prototype.toOrdinal = function() {
    if (this === -1)
        return 'منفی یکم';
    if (this < 0)
        return 'منفی ' + (-this).toOrdina();
    if (this === 1)
        return 'اول';
    if (this % 100 === 3)
        return this > 100 ? (Math.floor(this / 10) * 10).toText() + ' و سوم' : 'سوم';
    return this.toText() + 'م';
};

Number.prototype.scoreStatus = function(total) {
    if (this < total * 3 / 5)
        return window.gettext('Bad');
    if (this < total * 3 / 4)
        return window.pgettext('score', 'Average');
    if (this < total * 7 / 8)
        return window.gettext('Good');
    return window.gettext('Excellent');
};
